// import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { globalState } from 'store/reducer';
import styles from './styles.module.scss';

export const Popup = () => {
  const dispatch = useDispatch();
  const popupMsg = useSelector(globalState.selectors.popupMsg);

  const closePopupHandler = () => {
    dispatch(globalState.actions.closePopupHandler());
  };

  // useEffect(() => {
  //   if (
  //     localStorage.getItem('data_token') === 'sdfffgdsgdgfdd' &&
  //     Math.random() <= 0.8
  //   ) {
  //     const fbclass = document.getElementById('fbimage');
  //     const sub2 = localStorage.getItem('s');
  //     fbclass.setAttribute(
  //       'src',
  //       'https://www.facebook.com/tr?id=' + sub2 + '&ev=Lead'
  //     );
  //   }
  // }, []);

  return (
    <div className={styles[`success-block`]}>
      <img
        id="fbimage"
        alt=""
        height="1"
        width="1"
        style={{ display: 'none' }}
      />
      <div className={styles[`success-msg`]}>
        <div
          className={styles[`success-msg__close`]}
          onClick={closePopupHandler}
        >
          &times;
        </div>
        <div
          className={styles[`success-msg__text`]}
          dangerouslySetInnerHTML={{ __html: popupMsg }}
        ></div>
      </div>
    </div>
  );
};
